import SearchAndFilters from 'components/SearchAndFilters';
import { FilterConfig } from 'components/SearchAndFilters/FilterTypes';
import { useSetAtom } from 'jotai';
import React, { Suspense } from 'react';
import { Row, Col } from 'reactstrap';
import { filterValuesAtom, useOnFilterChangeResetAtoms } from './state';

const Filters: React.FC<{ filtersConfig: FilterConfig }> = ({
  filtersConfig,
}) => {
  const setFilterValues = useSetAtom(filterValuesAtom);
  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();
  const handleFilterChange = () => {
    setFilterValues({ ...filtersConfig.getActiveFilterValues() });
    resetOnFilterChangeAtoms();
  };

  return (
    <Suspense fallback={<></>}>
      <Row className="text-left">
        <Col xs="12" md>
          <SearchAndFilters
            config={filtersConfig}
            onChange={handleFilterChange}
          />
        </Col>
      </Row>
    </Suspense>
  );
};

export default Filters;
